<template>
	<span v-if="componentShow" style="cursor: pointer;" @click=setFullScreen>
		<img src="../../assets/icon/fang.png" v-if="!isFullScreen && color == 'white'">
		<img src="../../assets/icon/quanpingsuoxiao.png" v-else-if="isFullScreen && color == 'white'">
		<img src="../../assets/icon/fang1.png" v-else-if="!isFullScreen && color == 'black'">
		<img src="../../assets/icon/quanpingsuoxiao1.png" v-else>
	</span>
</template>
<script>
    export default {
        props: {
            color: {
                type: String,
                default: 'white'
            }
        },
        data() {
            return {
                isFullScreen: false,
                componentShow:true
            }
        },
        methods: {
            fullScreen(){
                var docElm = document.documentElement;
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen();
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen();
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                }
                this.isFullScreen = true;
            },
            closeFullScreen(){
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                }else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                this.isFullScreen = false;
            },
            setFullScreen() {
                if (this.isFullScreen) {
                    this.closeFullScreen()
                } else {
                    this.fullScreen();
                }
            },
            checkFull(){
                this.isFullScreen = this.getFull();
            },
            getFull(){
                let isFull = true;
                if(document.fullscreenEnabled != undefined && !document.fullscreenEnabled)
                    return false;
                if(window.fullScreen != undefined && !window.fullScreen)
                    return false;
                if(document.webkitIsFullScreen != undefined && !document.webkitIsFullScreen)
                    return false;
                if(document.msFullscreenEnabled != undefined && !document.msFullscreenEnabled)
                    return false;
                return isFull;
            }
        },
        created(){
            //添加窗体改变时间，用以控制全屏按钮
            window.addEventListener('resize', this.checkFull);
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fullScreen/index.vue